export function escapeHtml(value) {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}
export function renderRichText(content) {
    const escaped = escapeHtml(content);
    const markdownLinks = [];
    const withMarkdownLinks = escaped.replace(/\[(.*?)\]\((https?:\/\/[^\s)]+)\)/g, (_, label, url) => {
        const token = `__MD_LINK_${markdownLinks.length}__`;
        markdownLinks.push(`<a href="${url}" target="_blank" rel="noopener noreferrer">${label}</a>`);
        return token;
    });
    const withBareLinks = withMarkdownLinks.replace(/(^|[\s(>])(https?:\/\/[^\s<]+[^<.,!?;:\s)])/g, (_, prefix, url) => `${prefix}<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
    const withLinks = markdownLinks.reduce((html, link, index) => html.replace(`__MD_LINK_${index}__`, link), withBareLinks);
    const withInline = withLinks
        .replace(/^###\s+(.*)$/gm, "<h3>$1</h3>")
        .replace(/^##\s+(.*)$/gm, "<h2>$1</h2>")
        .replace(/^#\s+(.*)$/gm, "<h1>$1</h1>")
        .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
        .replace(/\*(.*?)\*/g, "<em>$1</em>")
        .replace(/`([^`]+)`/g, "<code>$1</code>");
    const withListItems = withInline.replace(/(?:^|\n)-\s+(.*?)(?=\n|$)/g, "<li>$1</li>");
    const wrappedLists = withListItems.replace(/(<li>.*<\/li>)/g, (match) => `<ul>${match}</ul>`);
    const paragraphs = wrappedLists
        .split(/\n{2,}/)
        .map((block) => `<p>${block}</p>`)
        .join("")
        .replace(/<p><ul>/g, "<ul>")
        .replace(/<\/ul><\/p>/g, "</ul>");
    return paragraphs;
}
